import { FunctionComponent, useState } from 'react'
import styles from './newsHandler.module.scss'
import NewsFeed from './newsFeed'
import NewsHeader from './header'
import EventComingSoon from './eventComingSoon'
import { useAuth } from '@/modules/context/AuthContext'
import { Navigate } from 'react-router-dom'
import SpinningSettingsIcon from '@/components/_custom/Buttons/SpinningSettingsIcon/SpinningSettingsIcon'

const NewsHandler: FunctionComponent = () => {
    const { user, device } = useAuth()

    const [sectionIds, setSectionIds] = useState<Array<number>>([])
    const [childIds, setChildIds] = useState<Array<number>>([])
    const [categoryIds, setCategoryIds] = useState<Array<number>>([])

    const [withoutSection, setWithoutSection] = useState<boolean>(true)
    const [countDraftPosts, setCountDraftPosts] = useState<number>(0)

    return (
        <div className={styles.PagePosition}>
            {user?.role &&
            user.currentDaycare &&
            user.currentDaycareRights &&
            user.currentDaycareRights.hasNewsAccess ? (
                <>
                    <NewsHeader
                        role={user.role}
                        currentDaycare={user.currentDaycare}
                        sectionIds={sectionIds}
                        setSectionIds={setSectionIds}
                        childIds={childIds}
                        setChildIds={setChildIds}
                        canReadNewsFeed={user.currentDaycareRights.canReadNewsFeed}
                        withoutSection={withoutSection}
                        setWithoutSection={setWithoutSection}
                        haveManyDaycares={user.daycares.length > 1}
                        countDraftPosts={countDraftPosts}
                    />
                    <div className={styles.EventNewsPlacement}>
                        {user.currentDaycareRights.canReadEvents && (
                            <EventComingSoon
                                daycare={user.currentDaycare}
                                role={user.role}
                                canUpdate={user.currentDaycareRights.canWriteEvents}
                            />
                        )}
                        {user.currentDaycareRights.canReadNewsFeed && (
                            <NewsFeed
                                daycare={user.currentDaycare}
                                role={user.role}
                                canUpdate={user.currentDaycareRights.canWriteNewsFeed}
                                canValidPosts={user.currentDaycareRights.canAddNewsWithoutValidation}
                                sectionIds={sectionIds}
                                childIds={childIds}
                                withoutSection={withoutSection}
                                isApplication={device?.platform !== 'web'}
                                setCountDraftPosts={setCountDraftPosts}
                                categoryIds={categoryIds}
                                setCategoryIds={setCategoryIds}
                            />
                        )}
                    </div>
                    <SpinningSettingsIcon section='newsSettings' />
                </>
            ) : (
                <Navigate to='/' replace />
            )}
        </div>
    )
}

export default NewsHandler
